module.exports = __webpack_public_path__ + "fonts/memnYaGs126MiZpBA-UFUKXGUdhrIqM.ebdfa24c.woff2";